var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_3949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9988 14.9591C17.977 13.5859 17.8577 11.6752 16.6261 10.4436C15.3057 9.12321 12.9734 9.1227 11.6548 10.4436C10.2801 11.8172 10.2808 14.0422 11.6548 15.415C12.8865 16.6476 14.7977 16.7652 16.1703 15.7877L19.1713 18.7188L19.9998 17.8902L16.9988 14.9591Z",
    fill: "#0067B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 0.34375V4.72699H14.9692L10.625 0.34375Z",
    fill: "#0067B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.14 17.6178C12.888 17.6178 11.711 17.1297 10.8258 16.2433C8.9932 14.413 8.99277 11.4467 10.827 9.61488C11.8721 8.56762 13.5287 7.99875 15.3125 8.4423V5.89844H9.45312V0H0V20H15.3125V17.4518C14.9323 17.5498 14.543 17.6178 14.14 17.6178ZM2.34375 7.07031H10.625V8.24219H2.34375V7.07031ZM8.28125 15.2734H2.34375V14.1016H8.28125V15.2734ZM8.28125 12.9297H2.34375V11.7578H8.28125V12.9297ZM8.28125 10.5859H2.34375V9.41406H8.28125V10.5859Z",
    fill: "#0067B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_3949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.4777500fb4f6e57fb52df8b9386f81e9.svg";
export { ForwardRef as ReactComponent };